import {
  Component,
  Input,
  OnChanges,
  EventEmitter,
  Output,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';

import { APP_CATEGORY_ROUTE, NUMBER_1, NUMBER_6 } from '~shared/constants';

import { Category } from '~app/modules/generic/models';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationEventService } from '~shared/modules/application-event/services/application-event.service';
import { CategoriesNavbarApplicationEventHandler } from '~app/modules/generic/helpers';
import { ProductsListUrlService } from '~app/modules/generic/services/products-list-url.service';
import { PROMO_CATEGORIES_ID } from '~app/modules/generic/constants/promo-constants';

@Component({
  selector: 'app-top-categories-navbar-second-level',
  templateUrl: './top-categories-navbar-second-level.component.html',
  styleUrls: ['./top-categories-navbar-second-level.component.scss'],
})
export class TopCategoriesNavbarSecondLevelComponent implements OnChanges, OnDestroy {
  @Input() childCategory: Category;
  @Input() parentCategory: Category;
  @Output() closeNestedCategoriesPopover = new EventEmitter();

  limitOption = NUMBER_6;
  categoryRoute = `/${APP_CATEGORY_ROUTE}`;
  NUMBER_1 = NUMBER_1;
  categoryExpandMap: { [key: string]: number } = {};
  private applicationEventHandler: CategoriesNavbarApplicationEventHandler;


  constructor(private translateService: TranslateService,
    private productsListUrlService: ProductsListUrlService,
    applicationEventService: ApplicationEventService) {
    this.applicationEventHandler = new CategoriesNavbarApplicationEventHandler(
      applicationEventService,
      this.translateService
    );
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.childCategory) {
      this.updateCategoryExpandMap();
    }
  }

  onNestedCategoryClick(nestedCategoryName: string, slugId: string, label?: string, parentCategoryName?: string): void {
    this.productsListUrlService.subCategoryId = slugId;
    const title = parentCategoryName ? `${parentCategoryName}/${nestedCategoryName}` : nestedCategoryName;
    this.applicationEventHandler.publishAppNavigation(title, label);
    this.closeNestedCategoriesPopover.emit();
  }



  queryParametersBuilder(childrenId, childCategoryId) {
    const queryParamsBag = {};
    if (childCategoryId === PROMO_CATEGORIES_ID) {
      queryParamsBag['f.promotion'] = true;
    }

    return queryParamsBag;
  }

  private updateCategoryExpandMap() {
    const optionsCount = this.childCategory.children.length;
    const limitOption =
      optionsCount <= this.limitOption
        ? this.limitOption
        : optionsCount > this.limitOption
        ? this.limitOption - NUMBER_1
        : this.limitOption;

    this.categoryExpandMap[this.childCategory.id] = limitOption;
  }

  toggleExpand(catId: string) {
    const currentCategories = this.childCategory.children.length;

    this.categoryExpandMap[catId] =
      this.categoryExpandMap[catId] < currentCategories
        ? currentCategories
        : this.limitOption - NUMBER_1;
  }

  ngOnDestroy() {
    this.applicationEventHandler.destroy();
  }
}
